module.exports = __webpack_public_path__ + "media/images/img_pr_male_2-d351a6ac10c4814c186cf6815a835681.png";